import script from "./QuantumControlUltracold.vue?vue&type=script&setup=true&lang=js"
export * from "./QuantumControlUltracold.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__